import { render, staticRenderFns } from "./ThongTinNhanVien.vue?vue&type=template&id=5d629505&scoped=true"
import script from "./ThongTinNhanVien.vue?vue&type=script&lang=js"
export * from "./ThongTinNhanVien.vue?vue&type=script&lang=js"
import style0 from "./ThongTinNhanVien.vue?vue&type=style&index=0&id=5d629505&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d629505",
  null
  
)

export default component.exports